import { StandardLink } from "@components/Link/StandardLink";
import { InsuranceClaimPageType_insuranceClaimPage_personalizedClaimLinksCollection_items } from "@containers/InsuranceClaimPage/queries/contentfulTypes/InsuranceClaimPageType";
import { getInternalOrExternalIcon } from "@utils/linkIconHelper";

import informationAreaStyles from "./InformationArea/InformationArea.module.css";

interface IInsuranceAreaLink {
  link?: InsuranceClaimPageType_insuranceClaimPage_personalizedClaimLinksCollection_items;
  insurance?: string;
  state?: "about" | "claim";
  index?: number;
  dataTestId?: string;
  contentfulPreviewEntryId?: string;
  contentfulPreviewLinkHeadingFieldId?: string;
}

const InformationAreaLink = ({
  link,
  insurance,
  dataTestId,
  index,
  contentfulPreviewEntryId,
  contentfulPreviewLinkHeadingFieldId,
}: IInsuranceAreaLink) => {
  const url = link?.url;
  const linkVariant = link?.variant && link?.variant?.toLowerCase() === "knapp" ? "button" : "link";
  const linkType = getInternalOrExternalIcon(link?.url, link?.reference, link?.globalLinkItem);

  return (
    url && (
      <StandardLink
        type={linkType}
        buttonStyle={index === 0 ? "primary" : "secondary"}
        text={link?.linkText}
        href={url}
        variant={linkVariant}
        target={link?.newTab ? "_blank" : "_self"}
        trackingData={{
          linkType: "barker",
          insurance: insurance,
        }}
        testId={dataTestId}
        className={informationAreaStyles.linkButton}
        contentfulEntryId={contentfulPreviewEntryId}
        contentfulFieldId={contentfulPreviewLinkHeadingFieldId}
      />
    )
  );
};

export default InformationAreaLink;
